import { observable } from "mobx";
import { EntityValidationRules } from "services/validationService";
import { Type } from "class-transformer";
import DomesticBankAccountResponse from "entities/domesticBankAccountResponse";

export enum PaymentType {
  GooglePay = "GOOGLE_PAY",
  PayGate = "PAY_GATE",
  Transfer = "TRANSFER",
}

export default class Payment {
  @observable
  paymentType?: PaymentType;

  variableSymbol?: number;

  specificSymbol?: number;

  paymentAmount?: number;

  @Type(() => DomesticBankAccountResponse)
  bankAccount?: DomesticBankAccountResponse;

  iban?: string;

  message?: string;

  dueDate?: Date;
}

export const PaymentValidationRules: EntityValidationRules<Payment> = {
  paymentType: {
    required: true,
  },
};
